import SupplierCapabilities from './SupplierCapabilities';
import SupplierCapabilitiesHOC from './SupplierCapabilitiesHOC';

export default SupplierCapabilitiesHOC(SupplierCapabilities);




// WEBPACK FOOTER //
// ./src/pages/SupplierCapabilities/index.jsx